module.exports = __webpack_public_path__ + "img/remove-file.344d1e5f.svg";